import { render, staticRenderFns } from "./ivst_concat.vue?vue&type=template&id=bf523e7e"
import script from "./ivst_concat.vue?vue&type=script&lang=js"
export * from "./ivst_concat.vue?vue&type=script&lang=js"
import style0 from "./ivst_concat.vue?vue&type=style&index=0&id=bf523e7e&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports